import { CheckCircle2, Loader2, XCircle } from 'lucide-react'
import { useEffect, useState } from 'react'
import { Link, useParams } from 'react-router-dom'

import { Button } from '@/components/button'
import { SideImageForm } from '@/components/side-image-form'
import api from '@/services/api'

export function ActivateEmail() {
  const { token } = useParams()

  const [isLoading, setIsLoading] = useState(true)
  const [isActivated, setIsActivated] = useState(false)

  useEffect(() => {
    api
      .post('/user/activate', { token })
      .then(() => {
        setIsActivated(true)
      })
      .catch(() => {
        setIsActivated(false)
      })
      .finally(() => {
        setIsLoading(false)
      })
  }, [token])

  const isSuccessfullyActivated = !isLoading && isActivated
  const isExpiredLink = !isLoading && !isActivated

  return (
    <div className="grid flex-1 grid-cols-1 bg-monochromatic-200 lg:grid-cols-9">
      <SideImageForm
        title="Seja um guardião ambiental"
        className="bg-registerPreserver"
      />

      <div className="my-auto space-y-6 px-10 py-5 text-center md:px-20 lg:col-span-4 xl:px-36 xl:pt-6 2xl:px-56 2xl:py-0 2xl:pb-6 2xl:pt-11">
        {isLoading && (
          <Loader2 className="mx-auto size-20 animate-spin text-monochromatic-500" />
        )}

        {isSuccessfullyActivated && (
          <CheckCircle2 className="mx-auto size-20 text-bios-primary" />
        )}

        {isExpiredLink && (
          <XCircle className="mx-auto size-20 text-alert-danger" />
        )}

        <h1 className="text-balance text-4xl font-bold text-monochromatic-500">
          {isSuccessfullyActivated && 'Cadastro ativado com sucesso'}

          {isExpiredLink && 'O link da ativação do cadastro expirou'}
        </h1>

        {isExpiredLink && (
          <p className="text-balance text-xl font-normal">
            Faça o login novamente e reenvie o link
          </p>
        )}

        {!isLoading && (
          <Button asChild>
            <Link to="/login">Realize o login</Link>
          </Button>
        )}
      </div>
    </div>
  )
}
